import { InvoiceResponse, PaymentInfoResponse } from '@fullstory/proto/fs/services/orgs';
import { combineReducers } from '@fullstory/redux-util/utils';
import { createRequestReducer, RequestActionType } from '@fullstory/redux-util';
import { BillingTypes } from './types';
import { BillingRequestActions } from './actions';

const invoices = (
  state: InvoiceResponse | null = null,
  action: RequestActionType<typeof BillingRequestActions>,
): InvoiceResponse | null => {
  switch (action.type) {
    case BillingTypes.GetInvoicesSuccess:
      return action.data;
    case BillingTypes.UpdateInvoiceInfoSuccess: {
      const body = action.request.body;
      if (body == null) {
        return state;
      }
      if (state == null) {
        return {
          name: body.InvoiceName,
          info: body.InvoiceInfo,
          email: '',
          invoices: [],
        };
      }
      return {
        ...state,
        name: body.InvoiceName,
        info: body.InvoiceInfo,
      };
    }
    default:
      return state;
  }
};

const paymentInfo = createRequestReducer<PaymentInfoResponse>()(
  BillingTypes.GetPaymentInfoRequest,
  BillingTypes.GetPaymentInfoSuccess,
  BillingTypes.GetPaymentInfoFailure,
);

type BillingReducerState = {
  invoices: ReturnType<typeof invoices>;
  paymentInfo: ReturnType<typeof paymentInfo>;
};

export const billingReducer = combineReducers<BillingReducerState>({
  invoices,
  paymentInfo,
});
